import { MeetingLocationTypeKeys } from './meeting-location-types.enum';

export const MEETING_LOCATION_TYPES_LOOKUP = [
  { value: MeetingLocationTypeKeys.physicalAddress, description: 'Physical Address' },
  { value: MeetingLocationTypeKeys.inboundCall, description: 'Inbound Call' },
  { value: MeetingLocationTypeKeys.outboundCall, description: 'Outbound Call' },
  { value: MeetingLocationTypeKeys.webConference, description: 'Web Conference' },
  { value: MeetingLocationTypeKeys.other, description: 'Other' },
];
